import { useMemo } from 'react';
import { toContentSuggestions } from './toContentSuggestions';
import { ContentSuggestionValue } from './ContentSuggestionValue';
import { useGetApiCategoryTreeQuery } from '../../../../redux/store/api/api';

const NONE: [] = [];

const useContentSuggestions = (): ContentSuggestionValue[] => {
  const { data: contentTreeData } = useGetApiCategoryTreeQuery();

  return useMemo(
    () =>
      contentTreeData?.resultObject
        ? toContentSuggestions(contentTreeData.resultObject)
        : NONE,
    [contentTreeData?.resultObject],
  );
};

export default useContentSuggestions;
